/* eslint-disable no-shadow */
import { make } from 'vuex-pathify';
// import axios from 'axios';

const DEFAULT_LOCALE = 'es';

const getDefaultState = () => ({
  locale: localStorage.getItem('user-locale') || DEFAULT_LOCALE,
  locales: ['eu', 'es'],
  loading: false,
});

const state = () => getDefaultState();

export const getters = {
  ...make.mutations(state),
  getLocales: state => () => state.locales,
  getLocale: state => () => state.locale,
};

const mutations = {
  ...make.mutations(state),
};

export const actions = {
  async changeLocale({ commit }, locale) {
    try {
      commit('SET_LOCALE', locale);
      window.Vue.$i18n.locale = locale;
      localStorage.setItem('user-locale', locale);
    } catch (e) {
      this.$i18n.locale = DEFAULT_LOCALE;
    }
  },
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
